

































import { mapActions } from 'vuex';

import { DeviceEnum } from '../../enums';

import { AUTH_CONSTS } from '../../store/auth/auth.consts';

import { UiButton, UiCheckbox } from '../keen-ui';
import LoginError from './login-error.component.vue';
import LoginInput from './login-input.component.vue';

export default {
  name: 'login-form',
  components: {
    LoginInput,
    UiCheckbox,
    UiButton,
    LoginError
  },
  data: function () {
    return {
      DeviceEnum,
      credentials: {
        username: undefined,
        password: undefined
      },
      keepLoggedIn: false,
      loading: false,
      errorMessage: undefined
    };
  },
  methods: {
    ...mapActions(AUTH_CONSTS.moduleName, {
      login: AUTH_CONSTS.actions.login
    }),
    onFormSubmit: function () {
      this.loading = true;
      this.login({
        credentials: this.credentials,
        keepLoggedIn: this.keepLoggedIn
      })
        .then(() => {
          this.loading = false;
          this.errorMessage = undefined;
          this.$emit('login', true);
        })
        .catch((error) => {
          this.loading = false;
          const errorMessages = this.$epb.messages.auth.errors;
          this.errorMessage = ((error.status === 401) ? errorMessages.invalidCredentials : errorMessages.default);
          this.$emit('login', false);
        });
    }
  },
  props: {
    resetPasswordUrl: String
  },
  watch: {
    'credentials.username': function (username: string): void {
      this.credentials.username = username.toLowerCase();
    }
  }
};

